export function chantierReducer(state = "" ,{
    type,
    payload
}){
    
    switch(type){
        case "NEW_CHANTIER":            
        case "UPDATE_CHANTIER":
            let list = Object.assign({}, state);
            list[payload.chantier_id] = payload
        
            return list
            
        case "GET_CHANTIERS":

            return payload
            
        default:
            return state;
    }
    
}